export default class AddressItem {
    constructor(element) {
        this.element = element;
    }
    getMarkerNode() {
        const elem = this.element.querySelector('.general');
        return elem;
    }
    getPopupNode() {
        const elem = this.element.querySelector('.address-item__popupcontent div');
        return elem;
    }
    getMarkerHtml() {
        const elem = this.getMarkerNode();
        if (elem)
            return elem.innerHTML;
        return "?";
    }
    getLatitude() {
        const elem = this.element.querySelector('input[name="latitude"]');
        if (elem)
            return Number(elem.value);
        return null;
    }
    getLongitude() {
        const elem = this.element.querySelector('input[name="longitude"]');
        if (elem)
            return Number(elem.value);
        return null;
    }
}
